import { IAppState } from '../../common/state';

export function selectNewbuildingPromoBuilderOffers(state: IAppState) {
  return state.newbuildingPromoBuilderOffers;
}
